import { render, staticRenderFns } from "./EditTransaction.vue?vue&type=template&id=d590e6b2&scoped=true&"
import script from "./EditTransaction.vue?vue&type=script&lang=js&"
export * from "./EditTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d590e6b2",
  null
  
)

export default component.exports